// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__33Jii","footer":"ModalUpdate_footer__3QwOA"};